import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, List, ListItem, Typography } from '@material-ui/core';
import styled from '@emotion/styled';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import { stringify, parse } from 'qs';
import { COLOR_TEXT_MAIN, COLOR_TEXT_SUBTITLE } from '../../../../theme/colors';
import OpenInNew from '@material-ui/icons/OpenInNew';

export type Page = {
  title: string;
  subTitle?: string;
  href?: string;
  category?: string[] | RegExp[];
  link?: string;
};

type Props = {
  pages: {
    title: string;
    subTitle?: string;
    href?: string;
    category?: string[] | RegExp[];
    link?: string;
    forbidden?: boolean; //リリース後消す
    admin?: boolean; //リリース後消す
  }[];
  onChangePage: (queryParams: string) => void;
  className?: string;
};

const SideBarNav: FC<Props> = ({ pages, onChangePage, className }) => {
  const { pathname } = useLocation();
  let queryParams = parse(useLocation().search.slice(1)) || {};

  const onClickButton = () => {
    queryParams['from'] = undefined;
    queryParams['to'] = undefined;
    queryParams['goal_id'] = undefined;
    queryParams['group'] = undefined;

    onChangePage(stringify(queryParams));
  };

  return (
    <List className={className}>
      {pages.map((page, index) => {
        // show super-admin only
        if (page.forbidden === true && !page.admin) {
          return;
        }
        return page.href ? (
          <ListItem
            button={true}
            component={Link}
            to={{ pathname: page.href /*, search: search*/ }}
            disableGutters
            key={page.title}
            onClick={onClickButton}
            style={{
              height: page.subTitle ? 58 : 40,
              padding: page.subTitle ? '9.5px 16px' : '13px 16px',
              borderRadius: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              alignContent: 'flex-start',
              backgroundColor: ((page, pathname) => {
                if (!page.category) {
                  return undefined;
                }
                for (let i = 0; i < page.category.length; i++) {
                  if (pathname.match(page.category[i])) {
                    return '#F5F6F7';
                  }
                }
                return undefined;
              })(page, pathname),
            }}
          >
            <NavText>{page.title}</NavText>
            {page.subTitle ? <NavDescription>{page.subTitle}</NavDescription> : null}
          </ListItem>
        ) : page.link ? (
          <ListItem
            // disableGutters
            key={page.title}
            style={{
              padding: '0px',
            }}
          >
            <Button
              href={page.link}
              target="_blank"
              style={{
                width: '100%',
                height: page.subTitle ? 58 : 40,
                padding: page.subTitle ? '9.5px 16px' : '13px 16px',
                borderRadius: 8,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                  }}
                >
                  <NavText>{page.title}</NavText>
                  {page.subTitle ? <NavDescription>{page.subTitle}</NavDescription> : null}
                </div>
                <OpenInNew style={{ color: COLOR_TEXT_MAIN }} />
              </div>
            </Button>
          </ListItem>
        ) : (
          <ListItem
            disableGutters
            key={page.title}
            style={{
              // height: 32,
              padding: '0px 16px',
              borderRadius: 8,
              marginTop: index === 0 ? 0 : 24,
              marginBottom: 8,
            }}
          >
            <NavTitle>{page.title}</NavTitle>
          </ListItem>
        );
      })}
    </List>
  );
};

const NavText = styled(Typography)(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
  {
    color: COLOR_TEXT_MAIN,
    fontWeight: 700,
    fontSize: 14,
    textTransform: 'none',
    letterSpacing: 0,
  },
);

const NavTitle = styled(Typography)(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
  {
    color: '#707889',
    fontWeight: 700,
    fontSize: 12,
    textTransform: 'none',
    letterSpacing: 0,
  },
);

const NavDescription = styled(Typography)(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
  {
    color: COLOR_TEXT_SUBTITLE,
    fontWeight: 400,
    fontSize: 8,
    lineHeight: '16px',
    textTransform: 'none',
    letterSpacing: 0,
  },
);

export default SideBarNav;
